// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7d47929b] .el-dialog{width:552px}.dialog-body div p[data-v-7d47929b]:first-child{font-size:16px;color:#686868}.dialog-body div p[data-v-7d47929b]:last-child{color:#ff3c32;font-size:12px}", ""]);
// Exports
module.exports = exports;
